import { render, staticRenderFns } from "./subscriber-growth.vue?vue&type=template&id=50643bc2"
import script from "./subscriber-growth.vue?vue&type=script&lang=js"
export * from "./subscriber-growth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports